<template>
  <div>
    <div class="col-md-12">
      <div class="modal-body">
        <label>Region</label>
        <select id="region" class="form-control" v-model="params.region">
            <option value="">Select Region</option>
            <option value="D010">NCR</option>
            <option value="RECSC20210001">CAR</option>
            <option value="D011">RO1</option>
            <option value="D012">RO2</option>
            <option value="D013">RO3</option>
            <option value="D014">RO4</option>
            <option value="RECSC20210002">RO4B</option>
            <option value="D015">RO5</option>
            <option value="D016">RO6</option>
            <option value="D017">RO7</option>
            <option value="D018">RO8</option>
            <option value="D019">RO9</option>
            <option value="D020">RO10</option>
            <option value="D021">RO11</option>
            <option value="D022">RO12</option>
            <option value="RECSC20120006">RO13</option>
            <option value="RECSC20230002">BARMM</option>
            <option value="D003">D2</option>
            <option value="D002">D3</option>
            <option value="RECSC20090004">D4</option>
            <option value="RECSC20070004">D5</option>
            <option value="RECSC20190001">D6</option>
        </select>
        <label>Start Date</label>
        <input type="date" v-model="params.startDate" class="form-control" />
        <label>End Date</label>
        <input type="date" v-model="params.endDate" class="form-control" />
      </div>
      <div class="modal-footer">
        <button @click="getReportUser()" type="button" class="btn btn-secondary">Download Report</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  authHeader,
  responseCheck,
  StatURL,
  downloadblob
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      params: {
        startDate: '',
        endDate: '',
        region: ''
      }
    }
  },
  methods: {
    getReportUser() {
      let loader = this.$loading.show()
      instance
        .get(StatURL + 'customstatregion', {
          params: this.params,
          headers: authHeader(),
          responseType: 'blob'
        })
        .then(response => {
          downloadblob('userstat.txt', response.data, 'text/plain')
          loader.hide()
        })
        .catch(function (error) {
          loader.hide();
          responseCheck(error.response.status)
        })
    }
  }
}
</script>